import React, { useState, useEffect } from 'react';
import '../Coaching/academyplayerlist.css';
import { useUser } from '../context/UserContext';
import { hasPrivilege } from '../utils/hasPrivilege';
import { useNavigate ,useSearchParams } from 'react-router-dom';
import { Link, useLocation } from 'react-router-dom';
import Swal from "sweetalert2";
import axios from "axios";

const BatchPlayerList = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const batchId = searchParams.get("batchId");
  const { userData } = useUser();
  const { academy } = location.state || {};
  const { selectedCenter, setSelectedCenter } = useUser();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [players, setPlayers] = useState([]);
  const token = localStorage.getItem('auth-token');
  const [selectedPlayers, setSelectedPlayers] = useState([]);

  useEffect(() => {
    const fetchPlayersData = async () => {
      if (!batchId) {
        setError('No batchId provided.');
        setLoading(false);
        return;
      }
      setLoading(true);
      try {
        const url = `${process.env.REACT_APP_API_ADD_PLAYER_BATCHES}?batch_id=${batchId}`;

        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch players data');
        }

        const result = await response.json();

        if (result.success) {
          const updatedPlayers = result.data.players.map((player) => {
            const playerId = player.id;
            return {
              id: playerId,
              user: player.user.id,
              name: player.user.name || '-',
              parentName: result.data.parentPlayer?.[playerId] || '-',
              parentMobile: '-',
              category: player.playerCategoryType || '-',
              level: player.playerLevelType || '-',
              mobile: player.user.mobile_number || '-',
              dob: formatDate(player.dateOfBirth) || '-',
              isEnrolled: result.data.isEnrollmentMap?.[playerId] || false,
              playingMember: result.data.playingMember?.[playerId] || false,
            };
          });

          setPlayers(updatedPlayers);
        }
        else {
          setError('No players found.');
        }
      } catch (error) {

        setError('Error fetching data: ' + error.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPlayersData();
  }, [batchId]);


  const formatDate = (dateString) => {
    if (!dateString || isNaN(Date.parse(dateString))) {
      return '-';
    }
    const dateOnly = dateString.split('T')[0];

    return dateOnly;
  };

  const headers = [
    { label: "Name", key: "name" },
    { label: "Parent Name", key: "parentName" },
    { label: "Category", key: "category" },
    { label: "Level", key: "level" },
    { label: "Date of Birth", key: "dob" },
  ];

  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setrowsPerPage] = useState(10);
  const [formData, setFormData] = useState({
    name: '',
    parentName: '',
    parentMobile: '',
    category: '',
    level: '',
    mobile: '',
    dob: '',
    isEnrolled: false,
    playingMember: false,
  });



  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setCurrentPage(1);
  };

  const filteredPlayers = players.filter((player) =>
    Object.values(player)
      .join(' ')
      .toLowerCase()
      .includes(searchTerm.toLowerCase())
  );


  const handlePageClick = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const [sortConfig, setSortConfig] = useState({
    key: "name",
    direction: "ascending",
  });

  const handleSort = (columnKey) => {
    let direction = "ascending";
    if (sortConfig.key === columnKey && sortConfig.direction === "ascending") {
      direction = "descending";
    }
    setSortConfig({ key: columnKey, direction });
  };

  const sortData = (data) => {
    const { key, direction } = sortConfig;
    return [...data].sort((a, b) => {
      if (a[key] < b[key]) return direction === "ascending" ? -1 : 1;
      if (a[key] > b[key]) return direction === "ascending" ? 1 : -1;
      return 0;
    });
  };

  const sortedData = sortData(filteredPlayers);
  const indexOfLastRow = currentPage * rowsPerPage;
  const indexOfFirstRow = indexOfLastRow - rowsPerPage;
  const currentRows = sortedData.slice(indexOfFirstRow, indexOfLastRow);
  const totalPages = Math.ceil(sortedData.length / rowsPerPage);

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage((prevPage) => prevPage - 1);
  };

  const generatePageNumbers = () => {
    const pages = [];
    const totalPagesToShow = 5;

    if (totalPages <= totalPagesToShow) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      pages.push(1);
      if (currentPage > 3) pages.push('...');
      for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
        pages.push(i);
      }
      if (currentPage < totalPages - 2) pages.push('...');
      pages.push(totalPages);
    }
    return pages;
  };

  const renderPagination = () => {
    return generatePageNumbers().map((page, index) =>
      typeof page === 'number' ? (
        <button
          key={index}
          className={`page-number ${currentPage === page ? 'active' : ''}`}
          onClick={() => handlePageClick(page)}
        >
          {page}
        </button>
      ) : (
        <span key={index} className="pagination-dots">
          {page}
        </span>
      )
    );
  };

  const handleCheckboxChange = (playerId) => {
    setSelectedPlayers(prevSelected =>
      prevSelected.includes(playerId)
        ? prevSelected.filter(id => id !== playerId)
        : [...prevSelected, playerId]
    );
  };


  const handleItemsPerPageChange = (event) => {
    setrowsPerPage(Number(event.target.value));
    setCurrentPage(1);
  };
  const totalEntries = filteredPlayers.length;
  const indexOfFirstEntry = (currentPage - 1) * rowsPerPage + 1;
  const indexOfLastEntry = Math.min(currentPage * rowsPerPage, totalEntries);


  const handlePlayerPayment = (event) => {
    if (selectedPlayers.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Please select at least one player before proceeding.',
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
      });
      return;
    }
  
    const url = `/addPlayerPayment?batchId=${batchId}&playerId=${selectedPlayers.join(',')}`;
  
    if (event?.metaKey || event?.ctrlKey) {
      window.open(url, "_blank");
    } else {
      navigate(url); 
    }
  };
  

  return (
    <div className="enrollment-container">

      <div className="search-bar">
        <div className="input-container">
          <input
            type="text"
            id="searchInput"
            placeholder=""
            className={`search-input ${searchTerm ? "has-value" : ""}`}
            value={searchTerm}
            onChange={handleSearchChange}
          />
          <label htmlFor="searchInput" className="floating-label">
            🔍 Search
          </label>
        </div>
        <button className="create-button" onClick={(e) => handlePlayerPayment(e)}>
  Next
</button>

      </div>

      <select className="items-per-page-select" value={rowsPerPage} onChange={handleItemsPerPageChange}>
        <option value={10}>10 items per page</option>
        <option value={50}>50 items per page</option>
        <option value={75}>75 items per page</option>
        <option value={100}>100 items per page</option>
      </select>
      <div className="pagination-selector">
          <div className="button-group">
            <div className="group-label">Items per page:</div>
            <div className="button-options">
              {[10, 50, 75, 100].map((option) => (
                <button
                  key={option}
                  onClick={() =>
                    handleItemsPerPageChange({ target: { value: option } })
                  }
                  className={`page-button ${rowsPerPage === option ? 'active' : ''}`}
                >
                  <span className="button-text">{option}</span>
                </button>
              ))}
            </div>
          </div>
        </div>

      
      {loading && (
        <div className="premium-loader">
          <div className="progress-track">
            <div className="progress-bar"></div>
          </div>
          <div className="status-text">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </div>
      )}
      {error && <div className="error-message">{error}</div>}
      {!loading && !error && filteredPlayers.length === 0 && (
        <div className="error-message">No data available</div>
      )}

      <div className="payment-list-scroll-container" style={{  overflowY: 'auto' }}>
        <table className="payment-list-table">
          <thead>
            <tr>
              <th>Select</th>
              {headers.map((header) => (
                <th
                  key={header.key}
                  className="challenges-column"
                  onClick={() => handleSort(header.key)}
                >
                  {header.label}
                  {sortConfig.key === header.key ? (
                    sortConfig.direction === "ascending" ? <span> ↑</span> : <span> ↓</span>
                  ) : null}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {currentRows.map((player) => (
              <tr key={player.id}>
                <td>
                  <input
                    type="checkbox"
                    checked={selectedPlayers.includes(player.id)}
                    onChange={() => handleCheckboxChange(player.id)}
                  />
                </td>
                <td>{player.name}</td>
                <td>{player.parentName}</td>
                <td>{player.category}</td>
                <td>{player.level}</td>
                <td>{player.dob}</td>
              </tr>
            ))}
          </tbody>

        </table>
      </div>

      <div className="pagination">
        <div className="showing-entries">
          Showing {indexOfFirstEntry} to {indexOfLastEntry} of {totalEntries} entries
        </div>
        <button
          className="prev-button"
          onClick={handlePrevPage}
          disabled={currentPage === 1}
        >
          Previous
        </button>
        {renderPagination()}
        <button
          className="next-button"
          onClick={handleNextPage}
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>

    </div>
  );
};

export default BatchPlayerList
